import React from "react";
import { Play, ExternalLink } from "lucide-react";
import { Button } from "./ui/button";
import { useContent } from "../context/ContentContext";

const VideoCard = ({ video, badge }) => (
  <div className="relative rounded-sm overflow-hidden border border-neutral-800 bg-black">
    <div className="absolute inset-0 border border-red-600/20 pointer-events-none" />
    <div className="aspect-video w-full">
      <iframe
        className="w-full h-full"
        src={`https://www.youtube.com/embed/${video.youtubeId}`}
        title={video.title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
    <div className="p-5 flex items-center justify-between flex-wrap gap-3 bg-neutral-950">
      <div className="flex items-center gap-3">
        <span className="w-10 h-10 rounded-sm bg-red-600 flex items-center justify-center">
          <Play className="w-4 h-4 text-white" fill="white" />
        </span>
        <div>
          <div className="font-display text-xl text-white leading-tight">
            {video.title}
          </div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 font-heading mt-0.5">
            {video.duration}
          </div>
        </div>
      </div>
      <a
        href={video.url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs uppercase tracking-[0.25em] font-heading text-neutral-300 hover:text-red-500 inline-flex items-center gap-1"
      >
        Watch on YouTube <ExternalLink className="w-3 h-3" />
      </a>
    </div>
    {badge && (
      <span className="absolute top-3 left-3 z-10 text-[10px] uppercase tracking-[0.25em] font-heading bg-red-600 text-white rounded-sm px-2 py-1">
        {badge}
      </span>
    )}
  </div>
);

const Highlights = () => {
  const { highlightVideo, campVideo } = useContent();
  return (
    <section id="film" className="relative py-24 md:py-32 bg-neutral-950 border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="accent-bar" />
              <span className="text-xs uppercase tracking-[0.35em] text-neutral-400 font-heading">
                03 — Game Film
              </span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl text-white leading-none">
              ON <span className="text-red-600">TAPE</span>
            </h2>
          </div>
          <Button
            asChild
            variant="outline"
            className="btn-primary bg-transparent border-neutral-700 text-white hover:bg-neutral-900 hover:text-white font-heading uppercase tracking-widest rounded-sm"
          >
            <a href={highlightVideo.url} target="_blank" rel="noopener noreferrer">
              Open on YouTube <ExternalLink className="w-4 h-4 ml-2" />
            </a>
          </Button>
        </div>

        {/* Main highlight */}
        <VideoCard video={highlightVideo} badge="Featured" />

        {/* Secondary - FBU camp */}
        {campVideo && campVideo.youtubeId && (
          <div className="mt-12">
            <div className="flex items-center gap-3 mb-5">
              <span className="accent-bar" />
              <span className="text-xs uppercase tracking-[0.35em] text-neutral-400 font-heading">
                Camp Film
              </span>
            </div>
            <VideoCard video={campVideo} />
          </div>
        )}
      </div>
    </section>
  );
};

export default Highlights;
